// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__fOJsS","open":"Nav_open__Ok63w"};